(function(){
  function initEta(el){
  if(!el || el.getAttribute('data-eta-ready') === '1'){ return; }
  el.setAttribute('data-eta-ready','1');

  /* ---------------- CONFIG ---------------- */
  var CFG = {
    cutoffHour: 12,        // corte de despacho RM (no incluida -> 12:00 ya es "mañana")
    deliverEndHour: 20,    // fin de ventana de reparto -> tope de entrega del día
    tz: 'America/Santiago',// Chile CON horario de verano: el desfase se calcula dinámico
    // Feriados NACIONALES de Chile (sin reparto). Incluye TODOS los nacionales, no solo los irrenunciables,
    // porque el courier no entrega ningún feriado nacional. Quitá alguno solo si vos SÍ entregás ese día.
    holidays: [
      // 2026
      '2026-01-01', // Año Nuevo
      '2026-04-03', // Viernes Santo
      '2026-04-04', // Sábado Santo
      '2026-05-01', // Día del Trabajo
      '2026-05-21', // Glorias Navales
      '2026-06-29', // San Pedro y San Pablo
      '2026-07-16', // Virgen del Carmen
      '2026-08-15', // Asunción de la Virgen
      '2026-09-18', // Independencia Nacional
      '2026-09-19', // Glorias del Ejército
      '2026-10-12', // Encuentro de Dos Mundos
      '2026-10-31', // Iglesias Evangélicas
      '2026-11-01', // Todos los Santos
      '2026-12-08', // Inmaculada Concepción
      '2026-12-25', // Navidad
      // 2027
      '2027-01-01', // Año Nuevo
      '2027-03-26', // Viernes Santo
      '2027-03-27', // Sábado Santo
      '2027-05-01', // Día del Trabajo
      '2027-05-21', // Glorias Navales
      '2027-06-29', // San Pedro y San Pablo
      '2027-07-16', // Virgen del Carmen
      '2027-08-15', // Asunción de la Virgen
      '2027-09-18', // Independencia Nacional
      '2027-09-19', // Glorias del Ejército
      '2027-10-12', // Encuentro de Dos Mundos
      '2027-10-31', // Iglesias Evangélicas
      '2027-11-01', // Todos los Santos
      '2027-12-08', // Inmaculada Concepción
      '2027-12-25'  // Navidad
    ],
    // Nota: feriados regionales (ej. 07/06 Arica) y el Día de los Pueblos Indígenas (solsticio, ~20-21 jun)
    // no van incluidos. Si tu courier no entrega esos días, agregalos al array.
    showCutoffLine: true,  // muestra "Pídelo antes de las 12:00" cuando es HOY

    /* --- Detección de PREVENTA Globo clásico (botón inyectado por JS) --- */
    // Globo clásico pinta el botón DESPUÉS de cargar, por eso vigilamos el DOM.
    domFallbackSelectors: [
      '.GloboPreorderApp','#globo-preorder','.globo-preorder','.globo-pre-order',
      '[data-globo-preorder]','.preorder-now-button','.globopreorder-button'
    ],
    // También detecta botones cuyo texto sea "Pre-Order/Preventa" (Globo permite re-escribir el texto)
    preorderTextRegex: /pre[\s-]?order|pre[\s-]?venta|preventa|pre[\s-]?orden/i,
    watchMs: 4000,         // cuánto tiempo vigilamos la aparición del botón Globo, luego apaga el observer
    // 0  = MODO RÁPIDO: el badge se muestra ya y se OCULTA si aparece Globo (sin CLS; puede haber un destello en PDPs de preventa)
    // >0 = MODO SIN DESTELLO: el badge arranca oculto y se revela a los X ms si NO es preventa (introduce un pequeño shift)
    awaitPreorderMs: 0
  };

  /* ---- Fallback C: detectar el botón de preventa de Globo (inyección asíncrona) ---- */
  function findGlobo(){
    var scope = el.closest('form[action*="/cart/add"]') ||
                el.closest('.product, .product-form, [id^="MainProduct"], main') || document.body;
    try{ if(scope.querySelector(CFG.domFallbackSelectors.join(','))) return true; }catch(e){}
    var btns = scope.querySelectorAll('button, a, input[type="submit"]');
    for(var i=0;i<btns.length;i++){
      var t = (btns[i].textContent || btns[i].value || '').trim();
      if(t && CFG.preorderTextRegex.test(t)) return true;
    }
    return false;
  }

  if(el.getAttribute('data-fallback-dom') === 'true'){
    var awaitMode = CFG.awaitPreorderMs > 0;
    if(awaitMode){ el.style.display = 'none'; }   // arranca oculto hasta confirmar que NO es preventa

    if(findGlobo()){ el.remove(); return; }       // ya estaba pintado: no seguimos

    if('MutationObserver' in window){
      var done = false;
      var obs = new MutationObserver(function(){
        if(done) return;
        if(findGlobo()){ done = true; obs.disconnect(); el.remove(); }
      });
      obs.observe(document.body, { childList:true, subtree:true });

      setTimeout(function(){
        if(done) return;
        done = true; obs.disconnect();
        if(awaitMode && !findGlobo()){ el.style.display = ''; }  // confirmado no-preventa: revelar
      }, awaitMode ? CFG.awaitPreorderMs : CFG.watchMs);
    } else if(awaitMode){
      el.style.display = '';
    }
  }

  var DOW_ES = ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'];
  var labelNode  = el.querySelector('[data-eta-label]');
  var whenNodes  = el.querySelectorAll('[data-eta-when]');
  var countNode  = el.querySelector('[data-eta-count]');
  var cutoffNode = el.querySelector('[data-eta-cutoff]');
  var interiorNode = el.querySelector('[data-eta-interior]');
  var pill       = el.querySelector('.meller-eta__pill');

  /* Formateador de hora de Santiago (se crea UNA sola vez) */
  var tzFmt = new Intl.DateTimeFormat('en-CA',{
    timeZone: CFG.tz, hour12:false,
    year:'numeric', month:'2-digit', day:'2-digit',
    hour:'2-digit', minute:'2-digit'
  });
  function p2(n){ return (n<10?'0':'')+n; }
  function ymd(y,m,d){ return y+'-'+p2(m)+'-'+p2(d); }
  // Convierte una hora "de pared" de la zona (con DST) a timestamp UTC real
  function tzOffsetMs(ts){
    var f = new Intl.DateTimeFormat('en-US',{ timeZone: CFG.tz, hour12:false,
      year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit', second:'2-digit' });
    var q={}; f.formatToParts(new Date(ts)).forEach(function(x){ q[x.type]=x.value; });
    var h = q.hour === '24' ? 0 : +q.hour;
    return Date.UTC(+q.year, +q.month-1, +q.day, h, +q.minute, +q.second) - ts;
  }
  function zonedTimeToTs(y,m,d,hh,mm,ss){
    var guess = Date.UTC(y, m-1, d, hh, mm, ss);
    var off = tzOffsetMs(guess);
    var ts = guess - off;
    var off2 = tzOffsetMs(ts);
    if(off2 !== off){ ts = guess - off2; }
    return ts;
  }
  function isHoliday(y,m,d){ return CFG.holidays.indexOf(ymd(y,m,d)) > -1; }
  function isBusiness(y,m,d){
    var dow = new Date(Date.UTC(y,m-1,d)).getUTCDay();
    if(dow===0 || dow===6) return false;          // finde
    if(isHoliday(y,m,d)) return false;            // feriado
    return true;
  }
  // Suma N días HÁBILES a una fecha (salta finde y feriados)
  function addBusinessDays(y,m,d,n){
    var dt=new Date(Date.UTC(y,m-1,d)), added=0;
    while(added<n){
      dt.setUTCDate(dt.getUTCDate()+1);
      if(isBusiness(dt.getUTCFullYear(), dt.getUTCMonth()+1, dt.getUTCDate())) added++;
    }
    return dt;
  }
  // Resto de regiones: 48 a 72 hs hábiles desde el despacho -> rango de días reales (+2 a +3 hábiles)
  function interiorText(disp){
    var e=addBusinessDays(disp.y,disp.m,disp.d,2);
    var l=addBusinessDays(disp.y,disp.m,disp.d,3);
    return ' · llega entre el '+DOW_ES[e.getUTCDay()]+' y el '+DOW_ES[l.getUTCDay()];
  }

  /* Calcula etiqueta, día de entrega y deadline (20:00 del día de entrega) */
  function compute(){
    var p = {};
    tzFmt.formatToParts(new Date()).forEach(function(x){ p[x.type]=x.value; });
    var y=+p.year, mo=+p.month, da=+p.day, hh=+p.hour;
    var beforeCutoff = hh < CFG.cutoffHour;

    // día de despacho/entrega (mismo día: reparto en el día)
    var dd = new Date(Date.UTC(y,mo-1,da));
    var dispatchToday = isBusiness(y,mo,da) && beforeCutoff;
    if(!dispatchToday){
      do { dd.setUTCDate(dd.getUTCDate()+1); }
      while(!isBusiness(dd.getUTCFullYear(), dd.getUTCMonth()+1, dd.getUTCDate()));
    }
    var dY=dd.getUTCFullYear(), dM=dd.getUTCMonth()+1, dD=dd.getUTCDate();

    // diferencia de días naturales para la etiqueta
    var today0 = Date.UTC(y,mo-1,da);
    var diff = Math.round((Date.UTC(dY,dM-1,dD) - today0)/86400000);
    var word;
    if(diff===0) word='hoy';
    else if(diff===1) word='mañana';
    else word='el '+DOW_ES[ new Date(Date.UTC(dY,dM-1,dD)).getUTCDay() ];

    var deadline = zonedTimeToTs(dY, dM, dD, CFG.deliverEndHour, 0, 0);
    return { word:word, deadline:deadline, isToday:(diff===0), dispatch:{y:dY,m:dM,d:dD} };
  }

  /* Render del clock HH:MM:SS (con días si > 24h) */
  function fmt(ms){
    var s=Math.max(0,Math.floor(ms/1000));
    var d=Math.floor(s/86400); s-=d*86400;
    var h=Math.floor(s/3600);  s-=h*3600;
    var m=Math.floor(s/60);    s-=m*60;
    return (d>0? d+'d ':'') + p2(h)+':'+p2(m)+':'+p2(s);
  }

  var state = null;
  function paintLabel(st){
    var txt = 'LLEGA ' + st.word.toUpperCase();
    if(labelNode.textContent !== txt) labelNode.textContent = txt;
    for(var wi=0; wi<whenNodes.length; wi++){
      if(whenNodes[wi].textContent !== st.word) whenNodes[wi].textContent = st.word;
    }
    var showCut = CFG.showCutoffLine && st.isToday;
    if(cutoffNode){ cutoffNode.hidden = !showCut; }
    if(interiorNode){
      var it = interiorText(st.dispatch);
      if(interiorNode.textContent !== it) interiorNode.textContent = it;
    }
  }

  // 1) Etiqueta correcta al cargar (sincrónico, microscópico, sin timers)
  state = compute();
  paintLabel(state);

  // 2) Cronómetro PEREZOSO: solo arranca al pasar por encima / tocar / focus
  var timer = null;
  function tick(){
    var fresh = compute();
    if(fresh.word !== state.word){ state = fresh; paintLabel(state); } // refresca si cruzó 12:00 o medianoche
    countNode.textContent = fmt(state.deadline - Date.now());
  }
  function startTimer(){
    if(timer) return;
    tick();
    timer = setInterval(tick, 1000);
  }
  ['pointerenter','focusin','click'].forEach(function(ev){
    el.addEventListener(ev, startTimer, { once:true, passive:true });
  });

  // 3) Toque en mobile: abre/cierra el panel (en desktop lo maneja el CSS :hover)
  pill.addEventListener('click', function(){
    var open = el.getAttribute('data-open') === 'true';
    el.setAttribute('data-open', open ? 'false' : 'true');
    pill.setAttribute('aria-expanded', open ? 'false' : 'true');
  }, { passive:true });
  document.addEventListener('click', function(e){
    if(!el.contains(e.target) && el.getAttribute('data-open')==='true'){
      el.setAttribute('data-open','false');
      pill.setAttribute('aria-expanded','false');
    }
  }, { passive:true });

  // 4) Pausa el timer si el badge sale de la vista (ahorra CPU/batería)
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(!en.isIntersecting && timer){ clearInterval(timer); timer=null; }
      });
    }, { threshold:0 }).observe(el);
  }
  }

  function initAll(scope){
    var root = scope && scope.querySelectorAll ? scope : document;
    var badges = root.querySelectorAll('[data-meller-eta]:not([data-eta-ready])');
    for(var i=0;i<badges.length;i++){ initEta(badges[i]); }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(document); }, { once:true });
  }else{
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function(event){
    initAll(event.target || document);
  });
})();
